import { render } from "./tftf.vue?vue&type=template&id=1b7f64b4&scoped=true"
import script from "./tftf.vue?vue&type=script&lang=js"
export * from "./tftf.vue?vue&type=script&lang=js"

import "./tftf.vue?vue&type=style&index=0&id=1b7f64b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/the-thing-from-the-future/the-thing-from-the-future/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7f64b4"]])

export default __exports__